import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../../../store";
import {Router} from "@angular/router";
import {UserSubscription} from "../../../../../user/user-subscription";


@Component({
    selector: 'db-migrate-for-booster',
    templateUrl: './migrate-for-booster.component.html',
    styleUrls: ['./migrate-for-booster.component.scss'],
    standalone: false
})
export class MigrateForBoosterComponent implements OnInit, OnDestroy {
  @Input() currentSubscription: UserSubscription;

  constructor(
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<DbStoreState>,
    private _router: Router
  ) {}

  ngOnInit() {

  }

  ngOnDestroy() {
  }

}
